import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

/**
 * Service for google search related calls.
 */
@Injectable()
export class GoogleSearchResultsService {
    constructor(private requestService: ObservableRequestService) { }

    fetchSearchResults(searchText: String, pageNumber: Number): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.GOOGLE_SEARCH + "/" + searchText + "/" + pageNumber);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/googlesearchresults/google-search-results.service.ts